/* FIELDWRKS product page: gallery, variant selection, AJAX add-to-cart that drives
   Horizon's cart drawer, sticky mobile bar, computed delivery dates.
   Classic script on purpose: the cart-event bridge lives in fw-product-cart.js so
   that a missing import map (iOS < 16.4, Firefox < 108) or a blocked Shopify CDN
   cannot take the gallery and variant picker down with it. Add-to-cart then falls
   back to a normal form post. */
(function () {
  function money(cents, symbol) {
    var n = cents / 100;
    var s = n.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return symbol + s;
  }

  function init(root) {
    if (root.__fwPdp) return;
    root.__fwPdp = true;

    var allMains = Array.prototype.slice.call(root.querySelectorAll('[data-fw-pdp-main]'));
    var allThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-fw-pdp-thumb]'));
    var allSegs = Array.prototype.slice.call(root.querySelectorAll('[data-fw-pdp-progress] li'));
    var counter = root.querySelector('[data-fw-pdp-counter]');
    var frame = root.querySelector('[data-fw-pdp-frame]');
    var gallery = root.querySelector('[data-fw-pdp-gallery]');
    var navrow = root.querySelector('.fw-pdp__navrow');
    var mobile = window.matchMedia('(max-width: 989px)');
    // v2.62 media runs: Liquid marks every slide/thumb/dot with data-fw-run (the colour whose
    // run it belongs to, or "all" for shared media) and hides the runs of the other colours.
    // These lists only ever hold what is currently visible; applyRun() swaps them on colour change.
    var mains = [], thumbs = [], segs = [], ids = [];
    function runOf(el) { return el.getAttribute('data-fw-run') || 'all'; }
    function thumbRow(t) { return (t.closest && t.closest('li')) || t; }
    function build() {
      mains = allMains.filter(function (m) { return !m.hidden; });
      thumbs = allThumbs.filter(function (t) { return !thumbRow(t).hidden; });
      segs = allSegs.filter(function (s) { return !s.hidden; });
      ids = mains.map(function (m) { return m.getAttribute('data-media-id'); });
      mains.forEach(function (m, i) { m.setAttribute('aria-label', (i + 1) + ' of ' + mains.length); });
      if (navrow) navrow.hidden = ids.length < 2;
    }
    function applyRun(run) {
      var has = allMains.some(function (m) { return runOf(m) === run; });
      if (!has) run = 'all';
      function place(el) {
        var r = runOf(el); el.hidden = !(run === 'all' || r === run || r === 'all');
        // a hidden run's video poster is deferred (data-fw-poster) so it costs nothing until the run shows
        var v = !el.hidden && el.querySelector && el.querySelector('video[data-fw-poster]');
        if (v) { v.setAttribute('poster', v.getAttribute('data-fw-poster')); v.removeAttribute('data-fw-poster'); }
      }
      allMains.forEach(place); allThumbs.forEach(function (t) { place(thumbRow(t)); }); allSegs.forEach(place);
      if (gallery) gallery.setAttribute('data-fw-run-active', run);
      build();
      return run;
    }
    build();
    function paint(idx) {
      mains.forEach(function (m, i) {
        m.classList.toggle('is-active', i === idx);
        var v = m.querySelector('video');
        if (!v) return;
        if (i === idx) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) { v.pause(); v.currentTime = 0; }
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
        if (i === idx && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      segs.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + ids.length;
      // Writing this during a swipe resizes the frame under the finger, so the
      // ratio only moves once the gesture has settled on a slide.
      var ar = parseFloat(mains[idx] && mains[idx].getAttribute('data-ar'));
      if (frame && ar && !frame.__fwSwiping) {
        frame.style.setProperty('--fw-ar', Math.min(Math.max(ar, 0.6), 1.6));
      }
    }
    function current() {
      if (mobile.matches && frame && frame.clientWidth) {
        return Math.min(ids.length - 1, Math.max(0, Math.round(frame.scrollLeft / frame.clientWidth)));
      }
      var i = -1; mains.forEach(function (m, k) { if (m.classList.contains('is-active')) i = k; });
      return i < 0 ? 0 : i;
    }
    function showMedia(id, instant) {
      if (!id) return;
      var idx = ids.indexOf(String(id));
      if (idx < 0) return;
      if (mobile.matches && frame) {
        frame.scrollTo({ left: idx * frame.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      }
      paint(idx);
    }
    function step(delta) {
      if (ids.length < 2) return;
      showMedia(ids[(current() + delta + ids.length) % ids.length]);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); });
    });
    segs.forEach(function (s) {
      s.addEventListener('click', function () { showMedia(s.getAttribute('data-media-id')); });
    });
    var prev = root.querySelector('[data-fw-pdp-prev]');
    var next = root.querySelector('[data-fw-pdp-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    // native swipe on mobile: keep the indicator in sync with the snap position
    if (frame) {
      var ticking = false;
      var settle;
      frame.addEventListener('scroll', function () {
        if (!mobile.matches || ticking) return;
        frame.__fwSwiping = true;
        clearTimeout(settle);
        settle = setTimeout(function () { frame.__fwSwiping = false; paint(current()); }, 120);
        ticking = true;
        requestAnimationFrame(function () { ticking = false; paint(current()); });
      }, { passive: true });
      mobile.addEventListener && mobile.addEventListener('change', function () { paint(current()); });
    }
    paint(0);

    // arrow keys when the stage is focused; touch swipe is native on mobile
    if (frame && allMains.length > 1) {
      var x0 = null;
      frame.addEventListener('touchstart', function (e) { if (!mobile.matches) x0 = e.touches[0].clientX; }, { passive: true });
      frame.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      }, { passive: true });
      frame.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      });
      // v2.32: desktop/tablet two-finger (trackpad) swipes and mouse drags page the gallery too.
      // A horizontal wheel burst counts once; vertical wheel keeps scrolling the page.
      var wheelAt = 0;
      frame.addEventListener('wheel', function (e) {
        if (mobile.matches) return;
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 6) return;
        e.preventDefault();
        var now = Date.now();
        if (now - wheelAt < 500) return;
        wheelAt = now;
        step(e.deltaX > 0 ? 1 : -1);
      }, { passive: false });
      var px0 = null;
      frame.addEventListener('pointerdown', function (e) { if (!mobile.matches && e.pointerType === 'mouse') px0 = e.clientX; });
      frame.addEventListener('pointerup', function (e) {
        if (px0 === null) return;
        var dx = e.clientX - px0; px0 = null;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      });
      frame.addEventListener('pointercancel', function () { px0 = null; });
    }

    var dataEl = root.querySelector('[data-fw-pdp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) {}
    // variant id -> colour run handle (Liquid writes it so the handles match the slides exactly)
    var runsEl = root.querySelector('[data-fw-pdp-runs]');
    var runMap = {};
    try { runMap = JSON.parse(runsEl ? runsEl.textContent : '{}'); } catch (e) {}
    var byVariant = !!(gallery && gallery.getAttribute('data-fw-by-variant') === 'true');
    // inventory is not part of the variants JSON any more; Liquid writes a small map
    var stockMap = {};
    try { stockMap = JSON.parse((root.querySelector('[data-fw-pdp-stock-map]') || {}).textContent || '{}'); } catch (e) {}
    var idInput = root.querySelector('[data-fw-pdp-id]');
    var priceEl = root.querySelector('[data-fw-pdp-price]');
    var titleEl = root.querySelector('[data-fw-pdp-variant-title]');
    var atc = root.querySelector('[data-fw-pdp-atc]');
    var atcLabel = root.querySelector('[data-fw-pdp-atc-label]');
    var symbol = priceEl ? (priceEl.textContent.match(/^[^\d]*/) || [''])[0] : '';
    // Read the labels from data attributes, not from the rendered button: when the
    // first variant is sold out the button text is "SOLD OUT", which used to become
    // the "add" label and never changed back.
    var labels = {
      add: (atc && atc.getAttribute('data-add-label')) || 'ADD TO CART',
      soldOut: (atc && atc.getAttribute('data-soldout-label')) || 'SOLD OUT'
    };

    function applyVariant(v, silent) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price, symbol);
      var cmp = root.querySelector('[data-fw-pdp-compare]');
      var cmpVal = root.querySelector('[data-fw-pdp-compare-value]');
      if (cmp) {
        var on = v.compare_at_price && v.compare_at_price > v.price;
        cmp.hidden = !on;
        if (on && cmpVal) cmpVal.textContent = money(v.compare_at_price, symbol);
      }
      if (titleEl) titleEl.textContent = v.title;
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? labels.add : labels.soldOut;
      }
      var mediaId = v.featured_media && v.featured_media.id;
      var run = byVariant ? (runMap[String(v.id)] || 'all') : 'all';
      if (byVariant && gallery && run !== (gallery.getAttribute('data-fw-run-active') || 'all')) {
        // colour changed: swap the visible run and open it on its cover (instantly, no cross-colour slide)
        applyRun(run);
        showMedia(ids.indexOf(String(mediaId)) >= 0 ? mediaId : ids[0], true);
      } else if (mediaId && !silent) showMedia(mediaId);
      if (!silent) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      // stock line: real inventory only, never a fake counter
      var stock = root.querySelector('[data-fw-pdp-stock]');
      if (stock) {
        var th = parseInt(stock.getAttribute('data-low-threshold'), 10) || 0;
        var sm = stockMap[String(v.id)];
        var q = sm ? sm[0] : (typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null);
        var tracked = sm ? sm[1] : !!(v.inventory_management && v.inventory_management !== 'null');
        var low = v.available && tracked && q !== null && q > 0 && q <= th;
        stock.hidden = !low;
        if (low) stock.textContent = (stock.getAttribute('data-low-text') || 'Only [n] left').replace('[n]', q);
      }
      // EMI figure follows the price
      var emiEl = root.querySelector('[data-fw-emi]');
      var emiMonths = parseInt((root.querySelector('[data-fw-payment]') || {}).getAttribute ? root.querySelector('[data-fw-payment]').getAttribute('data-emi-months') : 0, 10) || 0;
      if (emiEl && emiMonths > 0) emiEl.textContent = Math.round(v.price / 100 / emiMonths).toLocaleString('en-IN');
      // sticky bar mirrors the selection
      var sp = root.querySelector('[data-fw-sticky-price]'); if (sp) sp.textContent = money(v.price, symbol);
      var sv = root.querySelector('[data-fw-sticky-variant]'); if (sv) sv.textContent = v.title;
      var si = root.querySelector('[data-fw-sticky-img]'); if (si && v.featured_image && v.featured_image.src) si.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '$1?width=120&');
      var sb = root.querySelector('[data-fw-sticky-atc]'); if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? labels.add : labels.soldOut; }
      var msg = root.querySelector('[data-fw-pdp-atc-msg]'); if (msg) msg.hidden = true;
    }
    // initial stock/EMI state for the pre-selected variant
    (function () { var cur = variants.filter(function (x) { return idInput && String(x.id) === idInput.value; })[0]; if (cur) applyVariant(cur, true); })();

    // single-option products: image swatches
    root.querySelectorAll('[data-fw-pdp-variant]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        root.querySelectorAll('.fw-pdp__swatch').forEach(function (s) {
          s.classList.toggle('is-active', s.contains(radio));
        });
        var v = variants.filter(function (x) { return String(x.id) === radio.value; })[0];
        applyVariant(v);
      });
    });

    // multi-option products: selects resolved against the variant list
    var selects = root.querySelectorAll('[data-fw-pdp-option]');
    if (selects.length) {
      function resolve() {
        var chosen = [];
        selects.forEach(function (s) { chosen[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
        var v = variants.filter(function (x) {
          return chosen.every(function (val, i) { return x.options[i] === val; });
        })[0];
        applyVariant(v);
      }
      selects.forEach(function (s) { s.addEventListener('change', resolve); });
    }


    // ---- add to cart: AJAX + Horizon's standard cart event so the native drawer opens and re-renders
    var form = root.querySelector('[data-fw-pdp-form]');
    var msgEl = root.querySelector('[data-fw-pdp-atc-msg]');
    function eventsModule() {
      // Set by fw-product-cart.js once the standard cart events have loaded.
      return window.FWCartEvents ? Promise.resolve(window.FWCartEvents) : Promise.reject(new Error('cart events unavailable'));
    }
    function showMsg(text) { if (!msgEl) return; msgEl.textContent = text; msgEl.hidden = !text; }
    function addToCart() {
      if (!form || !atc || atc.disabled) return;
      var fd = new FormData(form);
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) { ids.push(el.dataset.sectionId); });
      if (!ids.length) ids.push('cart-drawer-section');
      fd.append('sections', ids.join(','));
      fd.append('sections_url', window.location.pathname);
      atc.classList.add('is-busy'); showMsg('');
      var sticky = root.querySelector('[data-fw-sticky-atc]'); if (sticky) sticky.disabled = true;
      var variantId = String(fd.get('id')), qty = parseInt(fd.get('quantity'), 10) || 1;
      eventsModule().then(function (ev) {
        var deferred = ev.CartLinesUpdateEvent.createPromise();
        var settle = function () {
          atc.classList.remove('is-busy');
          var s2 = root.querySelector('[data-fw-sticky-atc]'); if (s2) s2.disabled = atc.disabled;
        };
        try {
          form.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: qty }], promise: deferred.promise }));
        } catch (e) { console.error('[fw] cart event', e); }
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); })
          .then(function (res) {
            if (!res.ok || res.body.status) {
              var text = res.body.description || res.body.message || 'Could not add to cart';
              showMsg(text);
              try { form.dispatchEvent(new ev.CartErrorEvent({ error: text, code: 'INVALID', detail: { description: res.body.description } })); } catch (e) {}
              return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, itemCount: cart.item_count, source: 'fw-product', sourceId: 'fw-product' } });
              });
            }
            var sections = res.body.sections || {};
            var count = null;
            try {
              var doc = new DOMParser().parseFromString(sections[ids[0]] || '', 'text/html');
              var c = doc.querySelector('[ref="cartItemCount"]'); if (c) count = parseInt(c.textContent, 10);
            } catch (e) {}
            return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (cart) {
              if (typeof count !== 'number' || isNaN(count)) count = cart ? cart.item_count : null;
              try { if (window.fw2SetCartCount && typeof count === 'number') window.fw2SetCartCount(count); } catch (e) {}
              var cartObj;
              try { cartObj = cart ? ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : undefined; } catch (e) { cartObj = undefined; }
              deferred.resolve({ cart: cartObj, detail: { didError: false, items: [res.body], itemCount: count, productId: String(res.body.product_id), source: 'fw-product', sourceId: 'fw-product', sections: sections } });
            });
          })
          .catch(function (err) { console.error('[fw] add to cart failed', err); showMsg('Something went wrong. Please try again.'); deferred.reject(err); })
          .then(settle, settle);
      }, function (err) {
        // events module unavailable: fall back to a normal form post
        console.warn('[fw] events module unavailable, posting form', err);
        form.submit();
      });
    }
    // Only hijack the submit once the cart-event bridge is ready; otherwise the
    // browser performs its own POST to /cart/add and lands on the cart page.
    if (form) form.addEventListener('submit', function (e) {
      if (!window.FWCartEvents) return;
      e.preventDefault();
      addToCart();
    });
    var stickyBtn = root.querySelector('[data-fw-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (window.FWCartEvents) addToCart();
      else if (form) form.submit();
    });

    // ---- sticky bar: shows once the main button has scrolled above the viewport (mobile only)
    var stickyBar = root.querySelector('[data-fw-sticky]');
    if (stickyBar && atc && 'IntersectionObserver' in window) {
      var mqm = window.matchMedia('(max-width: 989px)');
      var pastAtc = false;
      // v2.5: with data-always the bar is pinned from the first screen on phones and
      // the inline button steps aside; without it, the bar waits for the button to scroll away.
      var always = stickyBar.hasAttribute('data-always');
      if (always) root.classList.add('fw-sticky-on');
      function paintSticky() {
        var on = (always || pastAtc) && mqm.matches;
        stickyBar.classList.toggle('is-visible', on);
        stickyBar.setAttribute('aria-hidden', on ? 'false' : 'true');
        document.documentElement.classList.toggle('fw-sticky-atc-visible', on);
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { pastAtc = !en.isIntersecting && en.boundingClientRect.top < 0; });
        paintSticky();
      }, { threshold: 0 }).observe(atc);
      mqm.addEventListener && mqm.addEventListener('change', paintSticky);
      paintSticky();
    }

    // ---- FW RUN launcher on phones: tucks away while the page scrolls, returns at rest
    (function () {
      var bubble = root.querySelector('.fw-pdp__play:not(.fw-pdp__play--badge)');   // v2.34: the badge stays put
      if (!bubble) return;
      var mqp = window.matchMedia('(max-width: 989px)');
      var lastY = window.pageYOffset, idle;
      window.addEventListener('scroll', function () {
        if (!mqp.matches) return;
        var y = window.pageYOffset;
        if (Math.abs(y - lastY) < 6) return;
        bubble.classList.toggle('is-tucked', y > lastY && y > 120);
        lastY = y;
        clearTimeout(idle);
        idle = setTimeout(function () { bubble.classList.remove('is-tucked'); }, 900);
      }, { passive: true });
    })();

    // ---- delivery window: computed from dispatch SLA and transit range, Sundays skipped
    var del = root.querySelector('[data-fw-delivery]');
    if (del) {
      var out = del.querySelector('[data-fw-delivery-dates]');
      var hours = parseInt(del.getAttribute('data-dispatch-hours'), 10) || 24;
      var dmin = parseInt(del.getAttribute('data-min'), 10) || 2, dmax = parseInt(del.getAttribute('data-max'), 10) || 5;
      function addDays(d, n) { var x = new Date(d); var k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0) k++; } return x; }
      var ship = new Date(Date.now() + hours * 3600 * 1000); if (ship.getDay() === 0) ship = addDays(ship, 1);
      var a = addDays(ship, dmin), b = addDays(ship, dmax);
      var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var f = function (d, withMonth) { return DAYS[d.getDay()] + ' ' + d.getDate() + (withMonth ? ' ' + MONTHS[d.getMonth()] : ''); };
      if (out) out.textContent = ' (' + (a.getMonth() === b.getMonth() ? f(a, false) + ' – ' + f(b, true) : f(a, true) + ' – ' + f(b, true)) + ')';
    }

    // ---- FW RUN launcher: centred pop-up everywhere; floating bubble on mobile
    var play = root.querySelector('.fw-pdp__play');
    var slot = root.querySelector('[data-fw-pdp-game-slot]');
    var stage = root.querySelector('.fw-pdp__stage');
    var mq = window.matchMedia('(max-width: 989px)');
    var modal = document.querySelector('[data-fw2-game]');

    // v2.54: the FW RUN badge (and its drag) moved to fieldwrk.js — it is rendered by the header on every shop page

    // v2.6: PLAY opens the game as a centred pop-up at every width. It used to be
    // moved into the gallery on desktop, which pushed the product photos away.


    if (play && mq.matches && !play.classList.contains('fw-pdp__play--badge')) {   // the badge is pinned to the corner, not draggable
      var KEY = 'fw-play-pos';
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
      function clamp(x, y) {
        var w = play.offsetWidth || 64, h = play.offsetHeight || 64, m = 8;
        return [Math.min(Math.max(x, m), window.innerWidth - w - m), Math.min(Math.max(y, m), window.innerHeight - h - m)];
      }
      function put(x, y) {
        var p = clamp(x, y);
        play.style.left = p[0] + 'px'; play.style.top = p[1] + 'px'; play.style.right = 'auto';
      }
      if (saved) {
        put(saved.x, saved.y);
      } else {
        // Rest over the photo, low-right, rather than on the buy box: the gallery is
        // the only area with no text to obscure. Drag moves it anywhere from there.
        var frameEl = root.querySelector('[data-fw-pdp-frame]');
        var h = play.offsetHeight || 64, w = play.offsetWidth || 64;
        var top = window.innerHeight * 0.45;
        if (frameEl) {
          var fr = frameEl.getBoundingClientRect();
          top = fr.bottom - h - 14;
        }
        put(window.innerWidth - 18 - w, Math.min(Math.max(top, 96), window.innerHeight - h - 96));
      }
      var start = null, moved = false;
      play.addEventListener('pointerdown', function (e) {
        var r = play.getBoundingClientRect();
        start = { x: e.clientX, y: e.clientY, left: r.left, top: r.top };
        moved = false;
        play.setPointerCapture(e.pointerId);
      });
      play.addEventListener('pointermove', function (e) {
        if (!start) return;
        var dx = e.clientX - start.x, dy = e.clientY - start.y;
        if (!moved && Math.hypot(dx, dy) < 8) return;
        moved = true;
        play.classList.add('is-dragging');
        put(start.left + dx, start.top + dy);
      });
      function end(e) {
        if (!start) return;
        start = null;
        play.classList.remove('is-dragging');
        if (moved) {
          var r = play.getBoundingClientRect();
          try { sessionStorage.setItem(KEY, JSON.stringify({ x: r.left, y: r.top })); } catch (err) {}
        }
      }
      play.addEventListener('pointerup', end);
      play.addEventListener('pointercancel', end);
      // a drag must not count as a tap
      document.addEventListener('click', function (e) {
        if (moved && play.contains(e.target)) { e.stopPropagation(); e.preventDefault(); moved = false; }
      }, true);
      window.addEventListener('resize', function () {
        var r = play.getBoundingClientRect(); put(r.left, r.top);
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-fw-pdp]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
